import { isNone } from '@ember/utils';
import { CATALOG_ATTR_TYPES, CATALOG_SERVICE_TYPES_INVERSE, CATALOG_SERVICE_TEMP_TOKEN_PREFIX } from '@square/dashboard-data/models/catalog/catalog-service-constants';
const ONE_PERCENT = 100000; // from https://git.sqcorp.co/projects/GO/repos/square/browse/items/model/merchant/attribute_definition.go,
// SquarePercent defines a percentage.  It is actually represented in parts per 10,000,000.  In
// that way, 10% is expressed as 1,000,000, etc.
// therefore, to get our percent as a value between 1 and 100, we divide by 100000

// eslint-disable-next-line complexity
export function deserializeCatalogAttributeValue(attrType, attrValue) {
  const stringValue = attrValue.string_value ?? attrValue.Value?.StringValue;
  const intValue = attrValue.int_value ?? attrValue.Value?.IntValue;

  // nulls are allowed only as unit overrides.
  // null attributes can be used to remove a global attribute from a single unit's perspective.
  if (isNone(stringValue) && isNone(intValue)) {
    return null;
  }
  switch (attrType) {
    case CATALOG_ATTR_TYPES.STRING:
    case CATALOG_ATTR_TYPES.TEXT:
    case CATALOG_ATTR_TYPES.TOKEN:
    case CATALOG_ATTR_TYPES.ITEM_OPTION:
    case CATALOG_ATTR_TYPES.ITEM_OPTION_VAL:
      return stringValue;
    case CATALOG_ATTR_TYPES.INT:
    case CATALOG_ATTR_TYPES.ENUM:
      return intValue;
    case CATALOG_ATTR_TYPES.BOOLEAN:
      if (intValue === 1) {
        return true;
      } else if (intValue === 0) {
        return false;
      } else {
        throw new Error(`invalid BOOLEAN attribute with int_value: ${intValue}`);
      }
    case CATALOG_ATTR_TYPES.PERCENT:
      if (isNone(intValue)) {
        return null;
      }
      return intValue / ONE_PERCENT;
    case CATALOG_ATTR_TYPES.JSON:
      if (isNone(stringValue)) {
        return null;
      }
      return JSON.parse(stringValue);
    case CATALOG_ATTR_TYPES.STRING_AND_INT:
    case CATALOG_ATTR_TYPES.TOKEN_AND_INT:
      return {
        string_value: stringValue,
        int_value: intValue
      };
    default:
      throw new Error(`unknown attrType: ${attrType}`);
  }
}
export function formatObjectAsCatalogResponse(catObj) {
  for (let index = 0; index < catObj.attribute.length; index++) {
    const attr = catObj.attribute[index];
    if (!isNone(attr.string_value)) {
      if (attr.string_value.lastIndexOf(CATALOG_SERVICE_TEMP_TOKEN_PREFIX, 0) === 0) {
        attr.string_value = attr.string_value.slice(CATALOG_SERVICE_TEMP_TOKEN_PREFIX.length);
      }
    }
  }
  catObj.type = CATALOG_SERVICE_TYPES_INVERSE[catObj.type];
  if (isNone(catObj.version)) {
    catObj.version = null;
  }
  return catObj;
}